export const defaultCalendarData = [
    {
        text:"Use the ",
        code:".main-inline-calender "
    },
    {
        text:"class through set all css property."
    }
]

export const bootstrapCalendarData= [
    {
        text:"Use the ",
        code:".form-control "
    },
    {
        text:"class through set all css property."
    }
]

export const datesPickerData = [
    {
        text:"Use the",
        code:".flatpickr-input "
    },
    {
        text:"through create date picker with javascript."
    }
]
export const TimePickerData = [
    {
        text:"Use the",
        code:".flatpickr-input "
    },
    {
        text:"through create time picker with javascript."
    }
]